export default __webpack_public_path__ + "media/images/features/yado/message_join-72801e0182d2a12e53d6f668d6bb9b95.png";